import React from 'react';
import { motion } from 'framer-motion';

const AnimatedText = ({ text }) => {
  const lines = text.split('\n');

  return (
    <motion.h1
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: 'easeOut', delay: 1 }}
    >
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </motion.h1>
  );
};

export default AnimatedText;